ACC.paginationsort = {
  downUpKeysPressed: false,
  articlesPageSize: 24,
  articlesCurrentPage: 0,
  otherContentPageSize: 24,
  otherContentCurrentPage: 0,
  articlesSort: 'newest',
  otherContentSort: 'name-asc',
  currentTab: null,

  bindAll: function () {
    const formsIdArr = ['sort_form1', 'sort_form2', 'page_form1', 'page_form2'];
    this.bindSortForms(formsIdArr);
    this.addPaginationListeners();
  },

  bindSortForms: function (formsIdArr) {
    const self = this;
    formsIdArr.forEach(function (formId) {
      $(document).on('change', `form#${formId}`, function (event) {
        // Check if we're on the archive tab
        if (self.isArchiveTabActive()) {
          event.preventDefault();
          return false;
        }

        const inputElem = $(this).find('input[name=q]');
        inputElem.val(decodeURIComponent(inputElem.val()));
        this.submit();
      });
    });
  },

  isArchiveTabActive: function () {
    const activeTabElement = document.querySelector('.pdl-tabs__item.is-active');
    return activeTabElement && activeTabElement.id === 'tab-search-results__archive';
  },

  addPaginationListeners: function () {
    this.addArticlesListeners();
    this.addOtherContentListeners();
  },

  addArticlesListeners: function () {
    $('#articles_page_form1, #articles_page_form2').change(function () {
      var form = $(this);
      if (typeof form.serializeArray === 'function') {
        var formFields = form.serializeArray();

        if (formFields.length) {
          ACC.paginationsort.articlesPageSize = formFields[0].value;
          ACC.paginationsort.articlesCurrentPage = 0;
          ACC.paginationsort.passPageSize = true;
          // Emulate a tab click to refresh the data
          $('#tab-search-results__articles').click();
        }
      }
    });

    $('#articles_page_sort_form1, #articles_page_sort_form2').change(function () {
      var form = $(this);
      if (typeof form.serializeArray === 'function') {
        var formFields = form.serializeArray();

        if (formFields.length) {
          ACC.paginationsort.articlesSort = formFields[0].value;

          // Emulate a tab click to refresh the data
          $('#tab-search-results__articles').click();
        }
      }
    });

    // Previous button
    $('#articles-search-page-prev').click(function (e) {
      ACC.paginationsort.articlesCurrentPage--;

      // Emulate a tab click to refresh the data
      $('#tab-search-results__articles').click();
    });

    // Next button
    $('#articles-search-page-next').click(function (e) {
      ACC.paginationsort.articlesCurrentPage++;

      // Emulate a tab click to refresh the data
      $('#tab-search-results__articles').click();
    });

    // Individual page numbers
    $('.articles-search-page-number').click(function (e) {
      ACC.paginationsort.articlesCurrentPage = $(e.target).data('page-number') - 1;

      // Emulate a tab click to refresh the data
      $('#tab-search-results__articles').click();
    });
  },

  addOtherContentListeners: function () {
    $('#other_content_page_form1, #other_content_page_form2').change(function () {
      var form = $(this);
      if (typeof form.serializeArray === 'function') {
        var formFields = form.serializeArray();

        if (formFields.length) {
          ACC.paginationsort.otherContentPageSize = formFields[0].value;
          ACC.paginationsort.otherContentCurrentPage = 0;
          ACC.paginationsort.passPageSize = true;

          // Emulate a tab click to refresh the data
          $('#tab-search-results__other-content').click();
        }
      }
    });

    $('#othercontent_page_sort_form1, #othercontent_page_sort_form2').change(function () {
      var form = $(this);
      if (typeof form.serializeArray === 'function') {
        var formFields = form.serializeArray();

        if (formFields.length) {
          ACC.paginationsort.otherContentSort = formFields[0].value;

          // Emulate a tab click to refresh the data
          $('#tab-search-results__other-content').click();
        }
      }
    });

    // Previous button
    $('#other-content-search-page-prev').click(function (e) {
      ACC.paginationsort.otherContentCurrentPage--;

      // Emulate a tab click to refresh the data
      $('#tab-search-results__other-content').click();
    });

    // Next button
    $('#other-content-search-page-next').click(function (e) {
      ACC.paginationsort.otherContentCurrentPage++;

      // Emulate a tab click to refresh the data
      $('#tab-search-results__other-content').click();
    });

    // Individual page numbers
    $('.other-content-search-page-number').click(function (e) {
      ACC.paginationsort.otherContentCurrentPage = $(e.target).data('page-number') - 1;

      // Emulate a tab click to refresh the data
      $('#tab-search-results__other-content').click();
    });
  },
};

$(function () {
  ACC.paginationsort.bindAll();
});
